module.exports = __webpack_public_path__ + "img/Logo.78469921.svg";